// Бесплатно: 1 ERID на аккаунт, далее — подписка от 1 425 ₽/мес
export const PROMO_DURATION_MONTHS = 0;
export const PROMO_HEADLINE = "1 ERID бесплатно при регистрации — далее от 1 425 ₽/мес";
export const PROMO_SHORT = "1 ERID бесплатно";
